import BankFormModal from "./BankFormModal";

export default BankFormModal;
